import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import repAPI from '../../sources/api/repAPI';

// constants
import { ACTIVATE_REP } from '../../constants/repTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { repSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';
import { ACTIVATE_REP_SUCCESS, ACTIVATE_REP_ERROR } from '../../constants/messages';

export function* activateRep(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(ACTIVATE_REP, call(repAPI.activateRep, params), repSchema);
    yield toastr.success('Success', ACTIVATE_REP_SUCCESS);
  } catch (e) {
    yield toastr.error(ACTIVATE_REP_ERROR);
    yield put(error(ACTIVATE_REP, e));
  } finally {
    yield put(doneIndicator(ACTIVATE_REP));
  }
}

export function* watchSearchRep() {
  yield takeEvery(ACTIVATE_REP, activateRep);
}

export default function* root() {
  yield all([
    fork(watchSearchRep)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/activateRep.js